import { computed } from "vue"

export const referral = (state) => {
  return computed(() => {
    return state.referral
  })
}
export const referralColumns = (state) => {
  return computed(() => {
    return state.referralColumns
  })
}
export const referrareferralMetalList = (state) => {
  return computed(() => {
    return state.referralMeta
  })
}